<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px">
      <b-col cols="12" md="9">
        <b-row class="mb-5">
          <b-col cols="12" class="mb-3">
            <h2 class="text-left mb-3">Ongoing Missions</h2>
          </b-col>
          <b-col
            cols="12"
            xl="6"
            class="mb-4"
            v-for="donat in dataOnGoingHome"
            :key="donat.id"
          >
            <div class="donatee d-flex">
              <img :src="donat.image" />
              <div
                class="donatee-info d-flex flex-column ml-3 ml-sm-4 pt-4 pt-sm-5 w-100 align-items-start"
              >
                <h2 class="mb-2 text-left donatee-name">{{ donat.name }}</h2>
                <div
                  class="d-flex flex-column text-left subscribed"
                  v-if="donat.subscribed"
                >
                  <span class="d-inline-block mb-1"
                    >Next Donation Period {{ donat.next_donation }}</span
                  >
                  <a
                    @click="cancelDonation(donat.id)"
                    class="cursor-pointer text-dark"
                    >Cancel Donation</a
                  >
                </div>
                <a
                  :href="`/#/donations?_d=${donat.id}`"
                  class="btn btn-primary"
                  v-if="!donat.subscribed"
                  >Donate Now</a
                >
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <h2 class="text-left mb-3">My Dashboard</h2>
            <div class="user-info d-flex flex-column flex-md-row">
              <b-col cols="12" md="6" class="d-flex user-info-1">
                <img
                  :src="!!userProfile.avatar ? userProfile.avatar : defaultLogo"
                  width="72"
                  height="72"
                  class="rounded-circle my-auto mr-3"
                />
                <div class="user-info-content">
                  <div class="user-name text-left">{{ userProfile.name }}</div>
                  <div class="user-email text-left">
                    {{ userProfile.email }}
                  </div>
                  <div class="user-date text-left">
                    <template v-if="!!userProfile">
                      <span v-if="userProfile.type === 0">{{
                        userProfile.joined
                      }}</span>
                      <span v-else-if="isMonthlySubscriber"
                        >Next Billing Period:
                        {{ moment(userProfile.subscription.end_date) }}</span
                      >
                      <span v-else-if="!isMonthlySubscriber"
                        >Premium Ends On:
                        {{ moment(userProfile.subscription.end_date) }}</span
                      >
                    </template>
                  </div>
                  <div class="user-date text-left">
                    <a
                      v-if="isMonthlySubscriber"
                      class="cursor-pointer text-dark"
                      @click="toggleManageSubscription"
                    >
                      Manage Membership</a
                    >
                  </div>
                </div>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="d-flex user-info-2 justify-content-between justify-content-md-end"
              >
                <div
                  class="my-auto mr-5 text-center user-info-link"
                  v-if="userProfile.type === 0 && paymentPendingStatus === ''"
                >
                  <span class="mb-2 label-btn-info-1"
                    >Listen to Songs in Full</span
                  >
                  <b-button variant="primary" to="/subscription">Join</b-button>
                </div>
                <div class="my-auto text-center user-info-link">
                  <span class="mb-2 label-btn-info-2"
                    >Credit {{ userProfile.credit_balance }}</span
                  >
                  <b-button variant="primary" to="/top-up">Top Up</b-button>
                </div>
              </b-col>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h2 class="text-left mb-3">Transaction History</h2>
            <b-tabs pills :active-nav-item-class="'custom-active-nav'">
              <b-tab title="Credit Purchase" active>
                <div class="w-100 mt-4"></div>
                <b-table
                  id="my-table"
                  :busy.sync="isBusy"
                  :items="fetchData"
                  :fields="fields"
                  :bordered="true"
                  :per-page="filter.per_page"
                  :current-page="filter.page"
                  :head-variant="'light'"
                  :hover="true"
                  class="rounded"
                  responsive
                >
                  <template #head()="data">
                    <span>{{ data.label }}</span>
                  </template>
                </b-table>
                <b-pagination
                  v-model="filter.page"
                  :total-rows="total"
                  :per-page="filter.per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </b-tab>
              <b-tab title="Content Purchase">
                <div class="w-100 mt-4"></div>
                <b-table
                  id="my-table2"
                  :bordered="true"
                  :items="fetchDataContent"
                  :fields="fieldsContent"
                  :per-page="filterContent.per_page"
                  :current-page="filterContent.page"
                  :head-variant="'light'"
                  :hover="true"
                  class="rounded"
                  responsive
                >
                  <template #cell(actions)="row">
                    <a
                      href="javascript:void(0)"
                      @click="
                        download(
                          row.item.item_id,
                          `${row.item.artist_name} - ${row.item.product_name}`,
                        )
                      "
                      v-if="row.item.type === 'song'"
                    >
                      Download
                    </a>
                    <a
                      href="javascript:void(0)"
                      @click="row.toggleDetails"
                      v-if="row.item.type === 'album'"
                    >
                      See Songs
                    </a>
                  </template>
                  <template #row-details="row">
                    <b-card>
                      <b-list-group>
                        <b-list-group-item
                          v-for="song in row.item.songs"
                          :key="song.id"
                          class="d-flex justify-content-between align-items-center"
                        >
                          {{ song.title }}
                          <a
                            href="javascript:void(0)"
                            @click="
                              download(
                                song.id,
                                `${row.item.artist_name} - ${song.title}`,
                              )
                            "
                            >Download</a
                          >
                        </b-list-group-item>
                      </b-list-group>
                    </b-card>
                  </template>
                </b-table>
                <b-pagination
                  v-model="filterContent.page"
                  :total-rows="totalContent"
                  :per-page="filterContent.per_page"
                  aria-controls="my-table2"
                ></b-pagination>
              </b-tab>
              <b-tab title="Donations">
                <div class="w-100 mt-4"></div>
                <b-table
                  id="my-table3"
                  :bordered="true"
                  :busy.sync="isBusyDonation"
                  :items="fetchDataDonation"
                  :fields="fieldsDonations"
                  :per-page="filterDonations.per_page"
                  :current-page="filterDonations.page"
                  :head-variant="'light'"
                  :hover="true"
                  class="rounded"
                  responsive
                >
                  <template #head()="data">
                    <span>{{ data.label }}</span>
                  </template>
                </b-table>
                <b-pagination
                  v-model="filterDonations.page"
                  :total-rows="totalDonations"
                  :per-page="filterDonations.per_page"
                  aria-controls="my-table3"
                ></b-pagination>
              </b-tab>
              <b-tab title="Download Receipt">
                <div class="w-100 mt-4"></div>
                <b-table
                  id="my-table4"
                  :bordered="true"
                  :busy.sync="isBusyReceipt"
                  :items="fetchDataReceipt"
                  :fields="fieldsReceipts"
                  :per-page="filterReceipts.per_page"
                  :current-page="filterReceipts.page"
                  :head-variant="'light'"
                  :hover="true"
                  class="rounded"
                  responsive
                >
                  <template #head()="data">
                    <span>{{ data.label }}</span>
                  </template>
                  <template #cell(actions)="row">
                    <a
                      href="javascript:void(0)"
                      @click="downloadReceipt(row.item.id)"
                    >
                      Download Receipt
                    </a>
                  </template>
                </b-table>
                <b-pagination
                  v-model="filterReceipts.page"
                  :total-rows="totalReceipts"
                  :per-page="filterReceipts.per_page"
                  aria-controls="my-table4"
                ></b-pagination>
              </b-tab>
              <b-tab title="Subscription Receipt">
                <div class="w-100 mt-4"></div>
                <b-table
                  id="my-table5"
                  :bordered="true"
                  :busy.sync="isBusySubscriptionReceipt"
                  :items="fetchDataSubscriptionReceipt"
                  :fields="fieldsSubscriptionReceipts"
                  :per-page="filterSubscriptionReceipts.per_page"
                  :current-page="filterSubscriptionReceipts.page"
                  :head-variant="'light'"
                  :hover="true"
                  class="rounded"
                  responsive
                >
                  <template #head()="data">
                    <span>{{ data.label }}</span>
                  </template>
                  <template #cell(actions)="row">
                    <a
                      href="javascript:void(0)"
                      @click="downloadSubscriptionReceipt(row.item.id)"
                    >
                      Download Receipt
                    </a>
                  </template>
                </b-table>
                <b-pagination
                  v-model="filterSubscriptionReceipts.page"
                  :total-rows="totalSubscriptionReceipts"
                  :per-page="filterSubscriptionReceipts.per_page"
                  aria-controls="my-table5"
                ></b-pagination>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import helperMixins from "../mixins/helpers.mixins";
import defaultLogo from "@/assets/user-icon.png";
import moment from "moment";
import fileDownload from "js-file-download";

export default {
  name: "HomePage",
  mixins: [helperMixins],
  data() {
    return {
      utc_offset: Math.floor(moment().utcOffset() / 60),
      isBusy: false,
      isBusyContent: false,
      isBusyDonation: false,
      isBusyReceipt: false,
      isBusySubscriptionReceipt: false,
      userProfile: null,

      fields: [
        { key: "trx_ref", label: "TRX ID", sortable: false },
        { key: "date", label: "Date/Time", sortable: true },
        { key: "purchase_channel", label: "Channel", sortable: true },
        { key: "amount_credit", label: "Credit", sortable: true },
        { key: "amount_dollar_text", label: "Amount Paid", sortable: true },
        { key: "redemption_code", label: "Redemption Code", sortable: false },
      ],
      fieldsContent: [
        { key: "uid", label: "TRX ID", sortable: false },
        { key: "date", label: "Date/Time", sortable: true },
        { key: "product_name", label: "Content", sortable: true },
        { key: "actions", label: "Action" },
      ],
      fieldsDonations: [
        { key: "stripe_charge_id", label: "TRX ID", sortable: false },
        { key: "date", label: "Date/Time", sortable: true },
        { key: "organization", label: "Mission", sortable: true },
        { key: "net_amount", label: "Amount", sortable: true },
        { key: "fee_amount", label: "Stripe Fees", sortable: true },
        { key: "final_amount", label: "Total Amount", sortable: true },
      ],
      fieldsReceipts: [
        { key: "stripe_charge_id", label: "TRX ID", sortable: false },
        { key: "date", label: "Date/Time", sortable: true },
        { key: "organization", label: "Mission", sortable: true },
        { key: "final_amount", label: "Amount", sortable: true },
        { key: "actions", label: "Action" },
      ],
      fieldsSubscriptionReceipts: [
        { key: "trx_ref", label: "TRX ID", sortable: false },
        { key: "date", label: "Date/Time", sortable: true },
        { key: "plan_name", label: "Plan", sortable: true },
        { key: "final_amount", label: "Amount", sortable: true },
        { key: "actions", label: "Action" },
      ],
      defaultLogo,
      data: [],
      dataContent: [],
      dataDonations: [],
      total: 0,
      totalContent: 0,
      totalDonations: 0,
      totalReceipts: 0,
      totalSubscriptionReceipts: 0,
      filter: {
        per_page: 20,
        page: 1,
      },
      filterContent: {
        per_page: 20,
        page: 1,
      },
      filterDonations: {
        per_page: 20,
        page: 1,
      },
      filterReceipts: {
        per_page: 20,
        page: 1,
      },
      filterSubscriptionReceipts: {
        per_page: 20,
        page: 1,
      },
      page: 1,
      pageContent: 1,
      pageDonations: 1,

      dataOnGoingHome: [],
      paymentPendingStatus: "",
      intervalCheck: null,
      showModalManage: false,
    };
  },
  computed: {
    ...mapGetters("PaymentModule", [
      "paymentPending",
      "intervalCheckPending",
      "subscriptionTrxData",
    ]),
    ...mapGetters("AuthModule", ["accessToken", "getUser"]),
    ...mapGetters("DonationsModule", ["listOnGoingHome"]),
    isSubsriber() {
      if (
        this.userProfile.type === 1 &&
        this.userProfile.subscription !== null
      ) {
        return true;
      }
      return false;
    },
    isMonthlySubscriber() {
      if (this.isSubsriber) {
        const condition1 = this.userProfile.subscription.recurring === 1;
        const condition2 = !this.userProfile.subscription.canceled;
        const condition3 =
          this.userProfile.subscription.canceled &&
          !this.userProfile.subscription.change_amount;
        if (condition1 && (condition2 || condition3)) {
          return true;
        }
      }
      return false;
    },
    isOneTimeSubscriber() {
      if (this.isSubsriber) {
        if (
          this.userProfile.subscription.canceled ||
          (!this.userProfile.subscription.canceled &&
            this.userProfile.subscription.recurring === 0)
        ) {
          return true;
        }
      }
      return false;
    },
  },
  async mounted() {
    this.userProfile = this.getUser.data;
    await this.requestDetailUser();
    await this.requestOnGoingHome();
  },
  watch: {
    getUser: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.userProfile = val.data;
      },
    },
    listOnGoingHome: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (val.length > 0) {
          this.dataOnGoingHome = val.map((donat) => {
            let nextDate = "";
            if (donat.subscribed) {
              if (this.utc_offset < 0) {
                nextDate = moment(donat.metadata.next_donation_period).subtract(
                  Math.abs(this.utc_offset),
                  "hour",
                );
              } else {
                nextDate = moment(donat.metadata.next_donation_period).add(
                  this.utc_offset,
                  "hour",
                );
              }
              nextDate = nextDate.format("DD MMM YYYY");
            }

            return {
              id: donat.id,
              name: donat.organization,
              image: donat.banner[0],
              total: donat.total_donation,
              subscribed: donat.subscribed,
              next_donation: nextDate,
            };
          });
        }
      },
    },
    paymentPending: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.paymentPendingStatus = val;
        if (this.paymentPendingStatus == "1") {
          const _this = this;
          this.intervalCheck = setInterval(() => {
            _this.intervalCheckPayment();
          }, 5000);
        } else if (this.getUser.data.type == 0) {
          this.removePaymentPending();
        }
      },
    },
  },
  methods: {
    ...mapActions("TransactionModule", [
      "requestListTransactions",
      "requestListContentPurchase",
      "requestDownloadSong",
    ]),
    ...mapActions("AuthModule", ["requestDetailUser"]),
    ...mapActions("PaymentModule", [
      "requestCancelSubscription",
      "requestCancelDonation",
      "requestConfirmPaymentSubscriptionPayMongo",
      "setIntervalCheckPending",
      "removeIntervalCheckPending",
      "removePaymentPending",
      "removePaymentDataSubscription",
      "removePaymentError",
    ]),
    ...mapActions("DonationsModule", [
      "requestOnGoingHome",
      "requestListDonationHistory",
      "requestDonationReceipt",
    ]),
    ...mapActions("SubscriptionModule", [
      "requestListSubscriptionHistory",
      "requestSubscriptionReceipt",
    ]),

    ...mapActions("NotificationModule", [
      "unsetLoading",
      "setManageMembership",
    ]),
    moment(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    async intervalCheckPayment() {
      const resp = await this.requestConfirmPaymentSubscriptionPayMongo({
        source_id: this.subscriptionTrxData.session_id,
      });
      const error =
        this.getStatus != 200 && this.getErrorCode == "error-paymongo-confirm";
      if (!error && resp.success) {
        clearInterval(this.intervalCheck);
        this.removeIntervalCheckPending();
        this.removePaymentDataSubscription();
        this.removePaymentError();
        this.removePaymentPending();
        await this.requestDetailUser();
      } else {
        let intv = 0;
        if (this.intervalCheckPending !== "") {
          intv = Number(this.intervalCheckPending);
        }
        if (intv <= 12) {
          this.setIntervalCheckPending(intv + 1);
        } else {
          clearInterval(this.intervalCheck);
          this.removeIntervalCheckPending();
          this.removePaymentDataSubscription();
          this.removePaymentError();
          this.removePaymentPending();
        }
      }
    },
    async fetchData(ctx) {
      this.isBusy = true;
      try {
        const response = await this.requestListTransactions(this.filter);
        this.isBusy = false;
        this.total = response.total;
        return response.data.map((trans) => {
          const amount_dollar_text = trans.final_currency
            ? `${trans.final_currency} ${trans.final_amount ? this.formatPrice(trans.final_amount) : 0}`
            : "-";
          const trx_ref = trans.trx_ref ? trans.trx_ref : "-";
          return {
            ...trans,
            amount_dollar_text,
            trx_ref,
            date: moment(trans.created_at).format("DD/MM/YYYY hh:mm A"),
            redemption_code: trans.redemption_code
              ? trans.redemption_code
              : "-",
          };
        });
      } catch (error) {
        this.isBusy = false;
        return [];
      }
    },
    async fetchDataContent(ctx) {
      this.isBusyContent = true;
      try {
        const response = await this.requestListContentPurchase(
          this.filterContent,
        );
        this.isBusyContent = false;
        this.totalContent = response.total;
        return response.data.map((trans) => ({
          ...trans,
          date: moment(trans.created_at).format("DD/MM/YYYY hh:mm A"),
          type: trans.type === 2 ? "album" : "song",
        }));
      } catch (error) {
        this.isBusyContent = false;
        return [];
      }
    },
    async fetchDataDonation(ctx) {
      this.isBusyDonation = true;
      try {
        const response = await this.requestListDonationHistory(
          this.filterDonations,
        );
        this.isBusyDonation = false;
        this.totalDonations = response.total;
        return response.data.map((trans) => ({
          ...trans,
          date: moment(trans.created_at).format("DD/MM/YYYY hh:mm A"),
          final_amount: trans.final_currency
            ? `${trans.final_currency} ${trans.final_price ? this.formatPrice(parseFloat(trans.final_price).toFixed(2)) : 0}`
            : "-",
          net_amount: trans.final_currency
            ? `${trans.final_currency} ${trans.net_revenue ? this.formatPrice(parseFloat(trans.net_revenue - trans.billing_fee).toFixed(2)) : 0}`
            : "-",
          fee_amount: trans.final_currency
            ? `${trans.final_currency} ${trans.fee ? this.formatPrice(parseFloat(trans.fee + trans.billing_fee).toFixed(2)) : 0}`
            : "-",
          organization: trans.donation[0].organization,
        }));
      } catch (error) {
        this.isBusyDonation = false;
        return [];
      }
    },
    async fetchDataReceipt(ctx) {
      this.isBusyReceipt = true;
      try {
        const response = await this.requestListDonationHistory(
          this.filterReceipts,
        );
        this.isBusyReceipt = false;
        this.totalReceipts = response.total;
        return response.data.map((trans) => ({
          ...trans,
          date: moment(trans.created_at).format("DD/MM/YYYY hh:mm A"),
          final_amount: trans.final_currency
            ? `${trans.final_currency} ${trans.final_price ? this.formatPrice(parseFloat(trans.final_price).toFixed(2)) : 0}`
            : "-",
          organization: trans.donation[0].organization,
        }));
      } catch (error) {
        this.isBusyReceipt = false;
        return [];
      }
    },
    async downloadReceipt(id) {
      try {
        const response = await this.requestDonationReceipt(id);
        if (!response) {
          this.$swal("Something Wrong. Please Try Again", "", "error");
          return;
        }
        const blob = new Blob([response.data], { type: "text/html" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } catch (error) {
        this.$swal("Something Wrong. Please Try Again", "", "error");
      }
    },
    async fetchDataSubscriptionReceipt(ctx) {
      this.isBusySubscriptionReceipt = true;
      try {
        const response = await this.requestListSubscriptionHistory(
          this.filterSubscriptionReceipts,
        );
        this.isBusySubscriptionReceipt = false;
        this.totalSubscriptionReceipts = response.total;
        return response.data.map((trans) => ({
          ...trans,
          date: moment(trans.created_at).format("DD/MM/YYYY hh:mm A"),
          final_amount: trans.final_currency
            ? `${trans.final_currency} ${trans.final_price ? this.formatPrice(parseFloat(trans.final_price).toFixed(2)) : 0}`
            : "-",
          plan_name:
            trans.recurring == 1 ? "Monthly Subscription" : "One-Time Subscription",
        }));
      } catch (error) {
        this.isBusySubscriptionReceipt = false;
        return [];
      }
    },
    async downloadSubscriptionReceipt(id) {
      try {
        const response = await this.requestSubscriptionReceipt(id);
        if (!response) {
          this.$swal("Something Wrong. Please Try Again", "", "error");
          return;
        }
        const blob = new Blob([response.data], { type: "text/html" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } catch (error) {
        this.$swal("Something Wrong. Please Try Again", "", "error");
      }
    },
    async cancelSubscription() {
      this.showModalManage = false;

      Vue.swal({
        title: "Cancel Membership",
        text: "You will lose your premium perks, including listening offline and donation to ministries. Are you sure you want to cancel your membership?",
        icon: "warning",
        confirmButtonText: "Cancel Membership",
        cancelButtonText: "I’ve Changed My Mind",
        showConfirmButton: true,
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-outline-primary",
          cancelButton: "btn btn-primary",
        },
      }).then(async (result) => {
        if (result.value) {
          const resp = await this.requestCancelSubscription();
          if (resp) {
            await this.requestDetailUser();
            this.$swal(
              "Membership Canceled",
              `You will have the premium access until ${this.moment(this.getUser.data.subscription.end_date)}. After that you won’t be charged for membership renewal.`,
              "success",
            );
          } else {
            this.$swal("Something Wrong. Please Try Again", "", "error");
          }
        }
      });
    },
    download(id, name) {
      this.requestDownloadSong(id).then((res) => {
        this.unsetLoading();
        fileDownload(res.data, `${name}.mp3`);
      });
    },
    async cancelDonation(donation_id) {
      Vue.swal({
        title: "Cancel Donation",
        text: "Are you sure to cancel the donation?",
        icon: "warning",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = {
            donation_id,
          };
          const resp = await this.requestCancelDonation(data);
          if (resp) {
            await this.requestOnGoingHome();
            this.$swal(
              "Cancel Donation",
              "Cancel donation success.",
              "success",
            );
          } else {
            this.$swal("Something Wrong. Please Try Again", "", "error");
          }
        }
      });
    },
    toggleManageSubscription() {
      this.setManageMembership(true);
    },
  },
};
</script>

<style scoped>
.custom-nav {
  background: yellow;
}

.cursor-pointer {
  cursor: pointer;
}

.user-info {
  min-height: 120px;
  background: #e5e5ea;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.user-info .user-info-1 {
  padding: 25px 0 25px 33px !important;
  justify-content: start;
}

.user-info .user-info-2 {
  padding: 25px 33px 25px 0 !important;
  justify-content: flex-end;
}

.user-info-content .user-name {
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 36px;
}

.user-info-content .user-email {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
}

.user-info-content .user-date {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
}

.credits-info span {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
}

.label-btn-info-1 {
  display: inline-block;
  width: 100px;
  word-break: break-word;
  text-align: center;
}

.label-btn-info-2 {
  display: inline-block;
  width: 50px;
  word-break: break-word;
  text-align: center;
}

.user-info-link {
  width: 100px;
}

.donatee {
  width: 100%;
  height: 166px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.donatee img {
  width: 166px;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 767.98px) {
  .user-info .user-info-1 {
    padding: 48px 34px 44px !important;
  }

  .user-info .user-info-2 {
    padding: 0px 25px 27px !important;
  }

  .donatee-info a {
    min-width: 112px;
  }

  .user-info-content .user-email {
    word-break: break-all;
  }
}

.donatee-info a {
  min-width: 112px;
}

.subscribed a {
  text-decoration: underline;
}

@media all and (max-width: 410px) {
  .donatee-name {
    font-size: 1.5rem;
  }

  .subscribed span,
  .subscribed a {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue